export const MINUTE_SECONDS = 60;
export const HOUR_SECONDS = 60 * MINUTE_SECONDS;
export const DAY_SECONDS = 24 * HOUR_SECONDS;
export const WEEK_SECONDS = 7 * DAY_SECONDS;

export const SECOND_MS = 1000;
export const MINUTE_MS = MINUTE_SECONDS * SECOND_MS;
export const HOUR_MS = HOUR_SECONDS * SECOND_MS;
export const DAY_MS = DAY_SECONDS * SECOND_MS;
export const WEEK_MS = 7 * DAY_MS;

export const NUM_MONTHS_IN_YEAR = 12;
